export default __webpack_public_path__ + "assets/images/e8a1bd6d246cd723986d5b0232da1544.png";